import React from "react";
import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";
import DateUtils from "../../../../shared/utils/DateUtils";
import TooltipGeneric from "../../../../shared/components/generic/tooltip/tooltip-generic";
import IconAction from "../../../../shared/components/generic/button/icon-action/icon-action";

const declineGreaterThanTooltipText = `O intervalo de cada faixa de queda do grupo está entre o valor cadastrado nela e o valor inicial da próxima faixa. Ex:
		QUEDA MAIOR QUE
		0%
		5%
	A primeira faixa vai de 0,01% a 5,00%.
	Se a segunda faixa muda para 10%, a primeira passa a estar entre 0,01% e 10%, e a segunda faixa cobrirá quedas a partir de 10,01%.`;

export const declineNetSalesColumnsConfig = ({
	onEdit,
	onDelete
}) => [
	{
        key: "declineGreaterThan",
        label: "% Queda maior que",
		label: (
			<span className="admin-table-header-tooltip">
				<span>% Queda maior que</span>

				<TooltipGeneric
					content={declineGreaterThanTooltipText}
					ariaLabel="Explicação sobre faixas de queda do grupo"
				/>
			</span>
		),
        width: "22%",
        render: row => {
            const percentage = MonetaryUtils.formatPercentage(row.declineGreaterThan);

            return (
                <span className="late-payment-penalty__delinquency-value">
                    {percentage ? `> ${percentage}` : "-"}
                </span>
            );
        }
    },
	{
		key: "penalty",
		label: "% penalidade",
		width: "22%",
		render: row => (
			<span className="late-payment-penalty__penalty-value">
				{MonetaryUtils.formatPercentage(row.penalty)}
			</span>
		)
	},
	{
		key: "createdAt",
		label: "Data de criação",
		width: "22%",
		render: row => DateUtils.formatDateToBrazilian(row.createdAt)
	},
	{
		key: "updatedAt",
		label: "Data da Última Atualização",
		width: "22%",
		render: row => DateUtils.formatDateToBrazilian(row.updatedAt)
	},
	{
		key: "actions",
		label: "Ações",
		width: "12%",
		render: row => (
            <IconAction
                row={row}
                actions={[
                    {
                        key: "edit",
                        variant: "edit",
                        title: "Editar",
                        onClick: onEdit
                    },
                    {
                        key: "delete",
                        variant: "delete",
                        title: "Excluir",
                        onClick: onDelete
                    }
                ]}
            />
        )
	}
];